import React, { useState, useEffect, useRef, Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import SessionConfig from "../../config/session_config"
import { useTranslation } from "react-i18next"
import config from "../../common/configuration"
//Import Flatepicker
import LabelChargeData from "../../components/Common/labelChargeData"
import { is_empty } from "../../config/validate"

import "flatpickr/dist/themes/material_blue.css"
import "./monitor.scss"
import Flatpickr from "react-flatpickr"
import service from "../../api/monitor.service"
import AsyncSelect from "react-select/async"
import Select from "react-select"
import dictionary from "../../config/dictionary"
import { formatDecimals } from "../../config/format"
import DataTable from "react-data-table-component"
import LinearIndeterminate from "../../components/Common/LinearIndeterminate"
import {
  Col,
  Row,
  Card,
  CardBody,
  UncontrolledDropdown,
  CardTitle,
  Form,
  Input,
  Label,
  InputGroup,
  Alert,
  FormGroup,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import moment from "moment"
import showToast from "../../components/Common/viewNotification"
import PendingDocuments from "../Dashboard/PendingDocuments"
import {
  initLoadTypesMonitor,
  initLoadOrders,
  initLoadUserData,
  cleanOrders,
  initExport,
  initLoadMessage,
} from "../../store/actions"

const Monitor = () => {
  const getDateMethod = () => {
    const dateAux = new Date()
    dateAux.setDate(dateAux.getDate() - 7)
    return moment(dateAux).format(config.form.date.formatBD)
  }
  const ref = useRef()
  const fp = useRef(null)
  const fi = useRef(null)

  const [toggleSwitch, settoggleSwitch] = useState(false)
  const [modal, setModal] = useState(true)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [date, setDate] = useState("")
  const [dateEnd, setDateEnd] = useState("")
  const [supplier, setSupplier] = useState({
    value: 0,
    label: t("monitor:supplierFind"),
  })
  const [type, setType] = useState({
    value: dictionary.configApp.type.orderNotPayed,
    code: dictionary.configApp.type.orderNotPayed,
    label: t("monitor:orderPending"),
  })
  const [exportType, setExportType] = useState("xls")
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(10)
  const [orderCode, setOrderCode] = useState({ value: "", error: "" })
  const [billNumber, setBillNumber] = useState({ value: "", error: "" })
  const [columns, setColumns] = useState([])
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
  // header title
  document.title = t("monitor:title") + " | " + t("global:title")
  //#region  store
  const {
    orders,
    loading,
    error,
    current,
    loadingSupplier,
    loadingType,
    types,
    exportXls,
    typesMessages,
    typesLoadding,
  } = useSelector(state => ({
    loading: state.Monitor.loading,
    orders: state.Monitor.orders,
    error: state.Monitor.error,
    exportXls: state.Monitor.export,
    current: state.Dashboard.user,
    loadingSupplier: state.SupplierMonitor.loading,
    loadingType: state.TypeMonitor.loading,
    types: state.TypeMonitor.types,
    typesMessages: state.MessageDashBoard.types,
    typesLoadding: state.MessageDashBoard.loading,
  }))
  useEffect(() => {
    if (exportXls) {
      buildXls()
    }
  }, [exportXls])
  //#endregion
  useEffect(() => {
    if (current?.supplier) {
      setSupplier(current.supplier)
      if (supplier?.code) {
        search()
      }
    }
  }, [current])
  useEffect(() => {
    loadUser()
    loadType()
  }, [auth])
  useEffect(() => {
    if (supplier?.code) {
      search()
    }
  }, [page, size])
  useEffect(() => {
    if (!is_empty(error)) {
      showToast(error, "error", t("error:title"))
    }
  }, [error])

  useEffect(() => {
    dispatch(cleanOrders())
    dispatch(initLoadMessage(dictionary.configApp.type.typeMessage))
    document.getElementById("body").className = "fondo4"
  }, [])

  const buildXls = async () => {
    const rows = []
    const wscols = !omitColumns()
      ? [
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 10 },
        { wch: 10 },
      ]
      : [{ wch: 50 }]
    const columnName = [
      t("monitor:orderCode"),
      t("monitor:bill"),
      t("monitor:description"),
      t("monitor:duedate"),
      t("monitor:paymentdate"),
      t("monitor:amount"),
      t("monitor:coin"),
      t("monitor:status"),
    ]
    exportXls?.map(row => {
      rows.push({
        orderCode: row.order.code,
        bill: row.billNumber,
        description: row.description,
        duedate: row.dueDate,
        paymentdate:
          row.status?.code === dictionary.configApp.type.orderPayed
            ? row.paymentDate
            : null,
        amount: row.amount?.toLocaleString("en"),
        coin: row.coin?.name,
        state: row.status?.name,
      })
    })
    if (omitColumns()) {
      rows.forEach(i => {
        delete i["orderCode"]
        delete i["bill"]
      })
      columnName.shift()
      columnName.shift()
    } else {
      rows.forEach(i => {
        delete i["description"]
      })
      columnName.splice(2, 1);
    }

    const XLSX = require("xlsx")
    var ws = XLSX.utils.json_to_sheet(rows)
    var wb = XLSX.utils.book_new()

    XLSX.utils.sheet_add_aoa(ws, [columnName], { origin: "A1" })
    //ancho de columnas
    ws["!cols"] = wscols
    if (rows.length > 0) {
      XLSX.utils.book_append_sheet(wb, ws, "Datos")
      let startDate = toggleSwitch
        ? moment(date, config.form.date.formatBD).format(
          config.form.date.formatPOSTGRES
        )
        : ""

      let endDate = toggleSwitch
        ? moment(dateEnd, config.form.date.formatBD).format(
          config.form.date.formatPOSTGRES
        )
        : ""
      let sign = toggleSwitch ? " - " : ""
      await XLSX.writeFile(
        wb,
        t("monitor:title") +
        " " +
        supplier?.name.toUpperCase() +
        " " +
        startDate +
        sign +
        endDate +
        "." +
        exportType
      )
      dispatch(cleanOrders())
    }
  }
  const loadType = () => {
    dispatch(initLoadTypesMonitor(dictionary.configApp.concept.paymentStatus))
  }
  const loadUser = () => {
    const request = {
      username: auth.id.user.username,
    }
    dispatch(initLoadUserData(request))
  }

  const loadSuppliers = filter => {
    if (auth) {
      const json = {
        username: auth?.id?.user?.username,
        length: 30,
        filter,
        societyCode: process.env.REACT_APP_STYLE_TEMPLATE,
      }
      return service.getSupplier(json)
      //dispatch(initLoadSuppliers(json))
    }
  }
  const loadingOptionSupplier = async (filter, callback) => {
    if (filter.length >= 3) {
      const data = await loadSuppliers(filter)
      const s = data?.data?.map(item => {
        return {
          ...item,
          value: item.code,
          label: item.name + " | " + item.code,
        }
      })
      callback(s)
    }
  }

  const onChangeSupplier = (value, action) => {
    setSupplier(value)
    if (action.action === "clear") {
      dispatch(cleanOrders())
    }
  }

  const onchangeDate = React.useCallback((selectedDates, dateStr, instance) => {
    if (instance?.element?.name === "dateStart") {
      setDate(dateStr)
    } else {
      setDateEnd(dateStr)
    }
  }, [])
  const search = async () => {
    const request = {
      startDate: toggleSwitch
        ? moment(date, config.form.date.formatBD).format(
          config.form.date.formatPOSTGRES
        )
        : "",
      endDate: toggleSwitch
        ? moment(dateEnd, config.form.date.formatBD).format(
          config.form.date.formatPOSTGRES
        )
        : "",
      length: size,
      societyCode: process.env.REACT_APP_STYLE_TEMPLATE,
      page: page,
      orderCode: orderCode.value,
      supplierCode: supplier?.code.trim(),
      state: is_empty(type?.code) ? null : type?.code,
      createdBy: auth.id.user.username,
      billNumber: billNumber?.value.trim(),
    }

    initColumns()
    await dispatch(initLoadOrders(request))
  }
  const searching = async () => {
    await setPage(0)
    await setSize(10)
    await search()
  }
  const omitColumns = () => {
    return supplier?.area?.code === dictionary.configApp.type.omit
  }
  const initColumns = () => {
    let col = [
      {
        name: t("monitor:orderCode"),
        sortable: false,
        wrap: true,
        width: "180px",
        omit: omitColumns(),
        cell: row => (
          <h5>
            <span className="text-primary">{row.order.code === 0 ? '' : row.order.code}</span>
          </h5>
        ),
      },
      {
        name: t("monitor:bill"),
        sortable: false,
        wrap: true,
        grow: 1,
        width: "220px",
        omit: omitColumns(),
        cell: row => <h5>{row.billNumber}</h5>,
      },
      {
        name: t("monitor:description"),
        sortable: false,
        wrap: true,
        grow: 1,
        width: "320px",
        omit: !omitColumns(),
        cell: row => <h6 className="text-muted ">{row.description}</h6>,
      },
      {
        name: t("monitor:duedate"),
        sortable: false,
        wrap: true,
        width: "180px",
        cell: row => (
          <h5>
            <i className="fa fa-calendar me-1 text-muted" />
            {row.dueDate}
          </h5>
        ),
      },
      {
        name: t("monitor:paymentdate"),
        sortable: false,
        wrap: true,
        width: "180px",

        // eslint-disable-next-line react/display-name
        cell: row =>
          row?.paymentDate &&
            row.status?.code !== dictionary.configApp.type.orderNotPayed ? (
            <h5>
              <i className="fa fa-calendar me-1 text-muted" />
              {row?.paymentDate}
            </h5>
          ) : null,
      },
      {
        name: t("monitor:amount"),
        sortable: false,
        wrap: true,
        width: "180px",
        right: true,
        cell: row => (
          <h5 className="text-primary ">
            {formatDecimals(
              parseFloat(row.amount).toFixed(2).toLocaleString("en")
            )}
          </h5>
        ),
      },
      {
        name: t("monitor:coin"),
        sortable: false,
        wrap: true,
        grow: 1,
        width: "180px",
        cell: row => <h5>{row.coin?.name}</h5>,
      },
      {
        name: t("monitor:status"),
        sortable: false,
        wrap: true,
        grow: 1,
        cell: row => (
          <div
            className={
              row.status?.code === dictionary.configApp.type.orderPayed
                ? "badge badge-soft-primary font-size-15 m-1"
                : "badge badge-soft-danger font-size-15 m-1"
            }
          >
            {row.status.name}
          </div>
        ),
      },
    ]
    setColumns(col)
  }
  const handlePerRowsChange = async (perPage, page) => {
    let pageRows = parseInt(page) - 1
    if (pageRows < 0) {
      pageRows = 0
    }
    await setPage(pageRows)
    await setSize(perPage)
  }
  const handlePageChange = async page => {
    let pageRows = parseInt(page) - 1
    if (pageRows < 0) {
      pageRows = 0
    }
    await setPage(pageRows)
  }
  const ExpandedComponent = ({ data }) => {
    const columns = []
    //setColumns(columns)
    return (
      <Alert color="primary" fade={false}>
        <DataTable
          fixedHeader
          fixedHeaderScrollHeight="500px"
          title={t("monitor:order") + ": " + data.code}
          data={data.orderDetails}
          columns={columns}
        />
      </Alert>
    )
  }
  const exportExcel = async () => {
    await setExportType("xls")
    await exportData()
  }
  const exportFile = async () => {
    await setExportType("csv")
    await exportData()
  }
  const exportData = async () => {
    const request = {
      startDate: toggleSwitch
        ? moment(date, config.form.date.formatBD).format(
          config.form.date.formatPOSTGRES
        )
        : "",
      endDate: toggleSwitch
        ? moment(dateEnd, config.form.date.formatBD).format(
          config.form.date.formatPOSTGRES
        )
        : "",
      length: 200000,
      societyCode: process.env.REACT_APP_STYLE_TEMPLATE,
      page: 0,
      orderCode: orderCode.value,
      supplierCode: supplier?.code,
      state: is_empty(type?.code) ? null : type?.code,
      createdBy: auth.id.user.username,
    }
    if (supplier?.code) {
      await dispatch(initExport(request))
    }
  }
  const listItems = typesMessages.map(item => (
    <Alert key={item.id} color="warning">
      <label className="text-primary">{item.name}</label>
      {": "}
      {item.text}
    </Alert>
  ))
  const toggle = () => setModal(!modal)
  return (
    <React.Fragment>
      <SessionConfig ref={ref} />
      <div className="page-content">
        <div>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle className="text-primary">
                    <h5>{t("monitor:title")}</h5>
                    <div className="form-check form-switch mb-3 ">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="customSwitch2"
                        defaultChecked={toggleSwitch}
                        onClick={e => {
                          settoggleSwitch(e?.target?.checked)
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="customSwitch2"
                      >
                        {t("monitor:filter")}
                      </label>
                    </div>
                  </CardTitle>
                  <Form className="row gy-2 gx-3 align-items-center">
                    {toggleSwitch ? (
                      <Fragment>
                        <div className="col-sm-auto col-lg-2">
                          <FormGroup className="mb-4">
                            <Label>
                              {" "}
                              {t("monitor:startDate")}{" "}
                              <span className="text-danger">(*)</span>
                            </Label>
                            <InputGroup>
                              <Flatpickr
                                name="dateStart"
                                className="form-control d-block"
                                value={date}
                                options={config.form.flatpickr}
                                onChange={onchangeDate}
                                disabled={loading}
                                ref={fi}
                              />
                              <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => {
                                  if (!fi?.current?.flatpickr) return
                                  fi.current.flatpickr.open()
                                }}
                              >
                                <i className=" fas fa-calendar me-1 "></i>
                              </button>
                            </InputGroup>
                          </FormGroup>
                        </div>
                        <div className="col-sm-auto  col-lg-2">
                          <FormGroup className="mb-4">
                            <Label>
                              {" "}
                              {t("monitor:endDate")}{" "}
                              <span className="text-danger">(*)</span>
                            </Label>
                            <InputGroup>
                              <Flatpickr
                                name="dateEnd"
                                className="form-control d-block"
                                value={dateEnd}
                                options={config.form.flatpickr}
                                onChange={onchangeDate}
                                disabled={loading}
                                ref={fp}
                              />
                              <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => {
                                  if (!fp?.current?.flatpickr) return
                                  fp.current.flatpickr.open()
                                }}
                              >
                                <i className=" fas fa-calendar me-1 "></i>
                              </button>
                            </InputGroup>
                          </FormGroup>
                        </div>
                      </Fragment>
                    ) : null}

                    {auth.id.role.transactionRol !==
                      process.env.REACT_APP_ROL_PROVIDER_CODE ? (
                      <div className="col-sm-auto min-Width-300 col-lg-4">
                        <FormGroup className="mb-4">
                          <Label>
                            {" "}
                            {t("monitor:supplier")}{" "}
                            <span className="text-danger">(*)</span>
                          </Label>
                          <AsyncSelect
                            //value={supplier}
                            loadOptions={loadingOptionSupplier}
                            maxMenuHeight={150}
                            cacheOptions
                            className="small-font text-uppercase"
                            isDisabled={loading}
                            placeholder={t("monitor:supplierFind")}
                            name="supplier"
                            isClearable
                            isLoading={loadingSupplier}
                            onChange={(value, action) => {
                              onChangeSupplier(value, action)
                            }}
                          />
                        </FormGroup>
                      </div>
                    ) : null}
                    {/* <div className="col-sm-auto col-lg-1">
                      <FormGroup className="mb-4">
                        <Label> {t("monitor:orderCode")}</Label>
                        <Input
                          autoComplete="new-text"
                          type="text"
                          className="form-control"
                          value={orderCode.value || ""}
                          onChange={e => {
                            setOrderCode({ value: e.target.value, error: "" })
                          }}
                          disabled={loading}
                        />
                      </FormGroup>
                    </div> */}
                    <div className="col-sm-auto col-lg-1">
                      <FormGroup className="mb-4">
                        <Label> {t("monitor:billNumber")}</Label>
                        <Input
                          autoComplete="new-text"
                          type="text"
                          className="form-control"
                          value={billNumber.value || ""}
                          onChange={e => {
                            setBillNumber({ value: e.target.value, error: "" })
                          }}
                          disabled={loading}
                        />
                      </FormGroup>
                    </div>
                    <div className="col-sm-auto col-lg-2 max-width-150">
                      <FormGroup className="mb-4">
                        <Label> {t("monitor:status")}</Label>
                        <Select
                          options={types}
                          isLoading={loadingType}
                          value={type}
                          cacheOptions
                          maxMenuHeight={150}
                          className="small-font text-uppercase"
                          isDisabled={loading}
                          name="type"
                          onChange={value => {
                            setType(value)
                          }}
                        />
                      </FormGroup>
                    </div>
                    <div className="col-sm-auto ">
                      <UncontrolledDropdown group>
                        <button
                          type="button"
                          className="btn btn-primary save-user"
                          disabled={loading}
                          onClick={search}
                        >
                          <i className=" fas fa-search me-1 " />
                        </button>
                        <DropdownToggle caret color="info">
                          {t("monitor:export")}
                          <i className=" fas fa-caret-down me-1 " />
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem onClick={exportExcel}>
                            <span className="">
                              <i className="text-success fas fa-file-excel me-1 " />
                              {t("monitor:excel")}
                            </span>
                          </DropdownItem>
                          <DropdownItem onClick={exportFile}>
                            <span className=" ">
                              <i className="text-info fas fa-file me-1 " />
                              {t("monitor:csv")}
                            </span>
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                    <Row>
                      <Col>
                        <LabelChargeData
                          label={""}
                          showloading={loadingSupplier}
                          title={t("global:loading")}
                        />
                      </Col>
                    </Row>
                    {supplier?.name ? (
                      <Alert color="primary">
                        <b className="alert-link me-1 ms-3">
                          {t("monitor:supplier")}:
                        </b>
                        {supplier?.name}
                        <b className="alert-link me-1 ms-3">
                          {t("monitor:code")}:
                        </b>
                        {supplier?.code}
                        <b className="alert-link me-1 ms-3">
                          {t("monitor:nit")}:
                        </b>
                        {supplier?.nit}
                      </Alert>
                    ) : null}
                  </Form>

                  <DataTable
                    columns={columns}
                    data={orders?.orders}
                    dense
                    fixedHeaderScrollHeight="600px"
                    pagination
                    paginationServer
                    paginationTotalRows={orders?.size}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    progressPending={loading}
                    progressComponent={<LinearIndeterminate />}
                    noDataComponent={t("tableOptions:noDataComponent")}
                    paginationComponentOptions={{
                      rowsPerPageText: t("tableOptions:rowsPerPageText"),
                      rangeSeparatorText: t("tableOptions:rangeSeparatorText"),
                      selectAllRowsItem: true,
                      selectAllRowsItemText: t(
                        "tableOptions:selectAllRowsItemText"
                      ),
                    }}
                  />
                  {auth.id.role.transactionRol ===
                    process.env.REACT_APP_ROL_PROVIDER_CODE ? (
                    <Modal isOpen={modal} toggle={toggle}>
                      <ModalHeader toggle={toggle}></ModalHeader>
                      <ModalBody>
                        {listItems}
                        {current?.supplier && <PendingDocuments typeShowModal={true}/>}
                      </ModalBody>
                    </Modal>
                  ) : null}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}
export default Monitor
